<template>
  <div class="goal-cycle-list">
    <div class="_items">
      <template
        v-for="(group, index) in cycleGroups"
        :key="index"
      >
        <goal-cycle-group
          :title="group.title"
          :children="group.children"
          :selected="selected"
          :selectable="selectable"
          :expanded="expandAll === true || index === 0"
          @select="select"
        />
      </template>
      <selector-item
        v-if="withUnassigned"
        :item="unassignedCycle"
        :selected="selected"
        :level="-1"
        :selectable="selectable"
        @select="select"
      />
    </div>
    <template v-if="editable">
      <m-divider none />
      <m-btn
        class="_btn"
        hide-border
        light
        block
        :button-style="{ justifyContent: 'normal' }"
        icon="settings"
        :to="goalCyclesSettings"
      >
        {{ $t('goalCycleSelector.manageCycles') }}
      </m-btn>
    </template>
  </div>
</template>

<script>
import GoalCycleGroup from '@/components/goal/cycle/GoalCycleGroup.vue';
import SelectorItem from '@/components/goal/cycle/SelectorItem.vue';
import useUnassignedGoalCycle from '@/composables/goal-cycle/unassigned-goal-cycle';
import { routeName } from 'shared/constants.json';

export default {
  name: 'GoalCycleList',
  props: {
    cycleGroups: {
      type: Array,
      required: true,
    },
    selected: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    withUnassigned: {
      type: Boolean,
      default: false,
    },
    expandAll: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { unassignedCycle } = useUnassignedGoalCycle();
    return { unassignedCycle };
  },
  emits: ['select'],
  components: { SelectorItem, GoalCycleGroup },
  computed: {
    goalCyclesSettings() {
      return { name: routeName.goalCycles };
    },
  },
  methods: {
    select(item) {
      if (!this.selectable) {
        return;
      }

      if (!this.multiple) {
        if (this.selected.map((c) => c.uid).includes(item.uid)) {
          this.$emit('select', []);
          return;
        }
        this.$emit('select', [item]);
        return;
      }

      const otherItems = this.selected.filter((c) => c.uid !== item.uid);
      if (otherItems.length === this.selected.length) {
        this.$emit('select', [...otherItems, item]);
        return;
      }

      this.$emit('select', otherItems);
    },
  },
};
</script>

<style
    scoped
    lang="scss"
    type="text/scss"
>
  .goal-cycle-list {
    ._items {
      max-height: 60vh;
      padding-bottom: .4rem;
      overflow: auto;

      @media (max-width: $screen-size-sm) {
        max-height: 100vh;
      }
    }

    ._btn {
      margin-top: .4rem;
    }
  }
</style>
